import styled from 'styled-components';

export const DrawerContainer = styled.div`
  width: 50vw;
  padding: 10px 15px;

  @media only screen and (max-width: 960px) {
    width: 75vw;
  }
`;

export const CloseButton = styled.button`
  width: 24px;
  height: 24px;

  margin: 15px 0 0 15px;
  background: transparent;
  border: none;
  color: #616161;

  transition: all 0.35s ease-in-out;

  &:hover {
    transform: scale(1.1);
    color: #d32f2f;
  }
`;
